import React from 'react';
import { Outlet, useOutletContext } from 'react-router-dom';
import { User } from '../../../../models/interfaces/User.interface';
import { BusinessObject } from '../../../../models/interfaces/BusinessObject.interface';
import BusinessObjectInfoCardComponent from '../business-object-context/components/business-object-info-card/business-object-info-card.component';

export default function CategoryContextComponent() {
  const { user, businessObject } = useOutletContext<{ user: User; businessObject: BusinessObject }>();

  return (
    <>
      <BusinessObjectInfoCardComponent businessObject={businessObject}></BusinessObjectInfoCardComponent>
      <Outlet context={{ user, businessObject }} />
    </>
  );
}
